export const DEFAULT_NICKNAME = "Bank Account";
export const TAC_URL = "https://kolmeo.com/terms-conditions/";
